<template>
  <div class="g-download">
    <div class="img_logo">
      <img src="../../assets/imgs/img_logo.png" alt="" />
    </div>
    <div class="download-content">
      <!-- <div class="tips">{{ i18n.download_tips }}</div> -->
      <div class="downloadbtn2 " @click="onDownload">
        <!-- <img src="@/assets/imgs/icon_app_logo.png" alt="" />
        <span>{{ i18n.download }}</span> -->
        <img src="@/assets/imgs/btn_download_app.png" alt="" />
      </div>
      <div class="device_img">
        <!-- <img :src="homebg" alt="" /> -->
        <img src="@/assets/imgs/shop/img_shop_cabinet.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  watch: {},
  computed: {
    ...mapState(["system"]),
    i18n() {
      return this.$t("result");
    },
    i18nMsg() {
      return this.$t("msg");
    },
    homebg() {
      return `${process.env.VUE_APP_DOMAIN}/content/introduction1.png`;
    }
  },
  data() {
    return {
      downloadApp: false
    };
  },
  methods: {
    onDownload() {
      let dowmloadUrl = process.env.VUE_APP_GOOGLE_PLAY;
      if (this.system === "ios") {
        dowmloadUrl = process.env.VUE_APP_APP_STORE;
      }
      if (dowmloadUrl) {
        window.open(dowmloadUrl);
      } else {
        this.$toast(this.i18nMsg.appoffline);
      }
    }
  }
};
</script>

<style lang="less">
.g-download {
  background-color: #292929;
  .img_logo {
    padding-top: 47px;
    img {
      display: block;
      margin: 0 auto;
      width: 39.73%;
      margin-bottom: 40px;
    }
  }
}
.download-content {
  background-color: #ffffff;
  // height: 72vh;
  // color: #fff;
  border-radius: 60px 60px 0 0;
  padding: 93px 0 0;
  .unlocked {
    max-width: 30%;
    display: block;
    margin: 0px auto;
    padding: 50px 0 0;
  }
  .device_img {
    position: relative;
    top: -36px;
    z-index: 2;
    padding: 0 36px;
    img {
      width: 100%;
      display: block;
      margin: 0px auto;
    }
  }
  .tips {
    line-height: 1.8;
    font-size: 28px;
    // color: #000;
    text-align: center;
    margin: 20px 60px 40px;
  }

  .downloadbtn {
    position: relative;
    height: 120px;
    margin: 0 56px;
    border-radius: 48px;
    font-size: 44px;
    font-weight: bold;
    color: #00ff00;
    background-color: #1a1a1a;
    box-shadow: 2px 4px 12px 0 rgba(0, 0, 0, 0.6);
    img {
      position: absolute;
      top: 6px;
      left: 6px;
      height: calc(100% - 12px);
    }
  }
  .downloadbtn2{
    position: relative;
    z-index: 3;
    padding: 0 20px;
    background-color:transparent;
    img {
      width: 100%;
    }
  }
}
</style>
